// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ZIgpF","requiredAsterisk":"Info_requiredAsterisk__3SHgT"};